import React from 'react';
import moment from 'moment';

import { Tags } from 'components/Tags/Tags';
import { CardContainerLink, CardTitle } from 'components/CardContainer/CardContainer';
import { CardDetails, DetailsLabel } from 'components/CardContainer/styles';

export default function ChallengeCard({ name, image, isTournament, createdAt, editedAt, link }) {
  const getEditedAtTime = () => {
    let time = editedAt ? editedAt : createdAt;
    let ago;
    let date = moment(time)._d;
    if (!time) {
      ago = '-';
    } else {
      ago = moment(date).fromNow();
    }
    return ago;
  };

  return (
    <CardContainerLink link={link} image={image} height={'265px'}>
      <CardTitle name={name} />
      <CardDetails>
        <DetailsLabel>Created At:&nbsp;</DetailsLabel>
        {moment(createdAt).format('ll')}
      </CardDetails>
      <CardDetails>
        <DetailsLabel>Edited At:&nbsp;</DetailsLabel>
        {getEditedAtTime()}
      </CardDetails>
      <Tags tags={[isTournament ? 'Tournament' : 'Challenge']} />
    </CardContainerLink>
  );
}
